function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Chilly (heat resist)");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M4.24 14.86a4.05 4.05 0 01-4-3 4.23 4.23 0 014-5 4.08 4.08 0 014 4 4.09 4.09 0 01-4 4z",
  fill: "#ff9700"
}), React.createElement("circle", {
  cx: 17.24,
  cy: 18.86,
  r: 7,
  fill: "#ff9700"
}), React.createElement("path", {
  d: "M4.09 30a4.07 4.07 0 01-4-3 4.24 4.24 0 014-5 4 4 0 010 8zM17.09 38a4.07 4.07 0 01-4-3 4.24 4.24 0 014-5 4 4 0 110 8zM30.09 15a4.07 4.07 0 01-4-3 4.24 4.24 0 014-5 4.08 4.08 0 014 4 4.08 4.08 0 01-4 4zM17.09 8a4.07 4.07 0 01-4-3 4.24 4.24 0 014-5 4.08 4.08 0 014 4 4.08 4.08 0 01-4 4z",
  fill: "#ff9700"
}), React.createElement("path", {
  fill: "#fff",
  d: "M22.24 28.86h4v-9l1-1h6l1 1v9h4v1l-8 8-8-8"
})));

var SvgChilly = function SvgChilly(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 38.24 38",
    width: 30,
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChilly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chilly.45aeb37d.svg";
export { ForwardRef as ReactComponent };